import ListGroup from '@pelckmans/elementis/components/list-group';
import Section from '@pelckmans/elementis/components/section';
import { useTranslation } from 'react-i18next';
import { Medialink } from '../../../../../api/medialink';
import MedialinkList from '../MedialinkList';
import { groupByContentType } from '../utils';

function splitUpMedialinksInExerciseAndNoneExercise(medialinks: Medialink[]) {
  const [exerciseMedialinks, noneExerciseMedialinks] = medialinks.reduce<[Medialink[], Medialink[]]>(
    ([exerciseMedialinks, noneExerciseMedialinks], medialink) => {
      if (medialink.contentType.isExercise) {
        exerciseMedialinks.push(medialink);
      } else {
        noneExerciseMedialinks.push(medialink);
      }
      return [exerciseMedialinks, noneExerciseMedialinks];
    },
    [[], []],
  );

  return {
    exercisesByContentType: groupByContentType(exerciseMedialinks),
    noneExercisesByContentType: groupByContentType(noneExerciseMedialinks),
  };
}

type MedialinkSectionsProps = {
  medialinks: Medialink[];
};

export default function MedialinkSections({ medialinks }: MedialinkSectionsProps) {
  const { t } = useTranslation();

  const { exercisesByContentType, noneExercisesByContentType } = splitUpMedialinksInExerciseAndNoneExercise(medialinks);

  return (
    <>
      {Object.keys(exercisesByContentType).length > 0 && (
        <Section title={t(`PAGES.TOC_LEVEL.SECTIONS.STUDENT.EXERCISE.TITLE`)}>
          <ListGroup>
            {Object.keys(exercisesByContentType).map(category => (
              <MedialinkList key={category} medialinks={exercisesByContentType[category]} title={category} />
            ))}
          </ListGroup>
        </Section>
      )}
      <Section
        title={t(`PAGES.TOC_LEVEL.SECTIONS.STUDENT.OTHER_MATERIAL.TITLE`)}
        emptyMessage={t(`PAGES.TOC_LEVEL.SECTIONS.STUDENT.OTHER_MATERIAL.EMPTY_MESSAGE`)}
      >
        {Object.keys(noneExercisesByContentType).length > 0 && (
          <ListGroup>
            {Object.keys(noneExercisesByContentType).map(category => (
              <MedialinkList key={category} medialinks={noneExercisesByContentType[category]} title={category} />
            ))}
          </ListGroup>
        )}
      </Section>
    </>
  );
}
